import { Button, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import MainCard from 'ui-component/cards/MainCard';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import AgentTable from './TableComponent';
import { FaFilterCircleXmark } from 'react-icons/fa6';
import { useState } from 'react';
import { useEffect } from 'react';

const CspTable = (props) => {



    let statusmap={
        "Active":"A",
        "Backend Config Done":"B",
        "Closed":"C",
        "Frontend Config Done":"F",
        "Inactive":"I",
        "Blocked":"K",
        "Replaced":"L",
        "Code Awaited":"P",
        "Deactivated & Replaced":"R",
        "To be replaced":"T",
        "Under Config":"U",
        "To be Replaced & Deactivated":"V",

    }
    const [FilterStatus, setFilterStatus] = useState({
        status: "select"
    })

  const [Data, setData] = useState(null);

  const handleFilterChange = (event) => {
    setFilterStatus({ ...FilterStatus, status: event.target.value });
    props.handleStatusFilterChange(event.target.value)
  };
  const handleClearFilter = () => {
    setFilterStatus({ status: 'select' });
    props.handleStatusFilterChange("select")
  };

  // console.log("props",props);

  // useEffect(() => {
  //   if (FilterStatus.status === '') {
  //     if (props.data) {
  //       setData(props.data.data); 
  //     }
  //   } else {
  //     if (props.data) {
  //       console.log(FilterStatus);

  //       let data = props.data?.data?.data
  //       let filteredData = data.filter((item) =>
  //         FilterStatus.status === 'select' ? true : statusmap[item.csp_code_status] === FilterStatus.status
  //       );

  //       props.data.data.data=filteredData
  //       console.log('filterd', data);

  //       // let op=

  //       setData(props.data.data);
  //     }
  //   }
  // }, [props.data, FilterStatus]);


  useEffect(() => {
      if (!props.data?.data) return;
  
      const rawData = props.data?.data; 
  
      if (FilterStatus.status === "" || FilterStatus.status === "select") {
          setData(rawData);
      } else {
          const filteredData = rawData.data.filter(
              item =>statusmap[item.csp_code_status] === FilterStatus.status
          );
  
          const newData = {
              ...rawData,             // keep page, totalPages, etc.
              data: filteredData      // replace only the data field
          };
  
          setData(newData);
      }
  }, [props.data, FilterStatus]);

  console.log("props",props);
  

  return (
    <MainCard sx={{ mt: 1 }}>
      <Grid container justifyContent="space-between">
        <Grid item md={12}>
          <Grid container spacing={2} justifyContent="space-between" alignItems="center">
            <Grid item md={5} xs={12} >
              <Box sx={{ minWidth: 120 }}>
                <Typography variant='h5' sx={{color:"#20415C",marginBottom:1}} fontWeight={600} >User List</Typography>
              </Box>
            </Grid>
            <Grid item md={3} xs={12}>
              <Stack direction="row" gap={1} alignItems="center">
              <Box sx={{ minWidth: 150 }}>
                <FormControl fullWidth size="small" variant="standard">
                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={FilterStatus.status ? FilterStatus.status : ''}
                    label="Status"
                    onChange={handleFilterChange}
                  >
                    <MenuItem value={'select'}>All</MenuItem>
                    <MenuItem value={'A'}>Active</MenuItem>
                    <MenuItem value={'B'}>Backend Config Done</MenuItem>
                    <MenuItem value={'C'}>Closed</MenuItem>
                    <MenuItem value={'F'}>Frontend Config Done</MenuItem>
                    <MenuItem value={'I'}>Inactive</MenuItem>
                    <MenuItem value={'K'}>Blocked</MenuItem>
                    {/* <MenuItem value={'L'}>Replaced</MenuItem> */}
                    <MenuItem value={'P'}>Code Awaited</MenuItem>
                    <MenuItem value={'R'}>Deactivated & Replaced</MenuItem>
                    <MenuItem value={'T'}>To be replaced</MenuItem>
                    <MenuItem value={'U'}>Under Config</MenuItem>
                    <MenuItem value={'V'}>To be Replaced & Deactivated</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Button variant="contained" color="secondary" onClick={handleClearFilter}>
                <FaFilterCircleXmark />
              </Button>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <AgentTable
            data={Data ? { data: Data } : null}
            filter={props.filter}
            FilterStatus={FilterStatus}
            handlePageChange={props.handlePageChange}
            handleGet={props.handleGet}
            page={props.page}
          />
        </Grid>
      </Grid>
    </MainCard>
  );
};

export default CspTable;
